import React from "react"
import StatCard from "./components/common/StatCard";
import UsersTable from "./components/tables/UsersTable";

export default class Dashboard extends React.Component {

  constructor(props) {
    super(props)

    this.state = {

    }
  }

  render() {
    let {

    } = this.state

    return (
      <>
        <div className="row">
          <div className="col-sm-12 col-xl-12">
            <UsersTable
              title={"Users"}
            />
          </div>
        </div>
      </>
    )
  }

}